import Menu from "./components/ResponsiveAppBar";
import { ThemeProvider } from "@mui/system";
import { createTheme } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import {
  Box,
  Container,
  CssBaseline,
  Button,
  Avatar,
  Typography,
} from "@mui/material";
import BasicTable from "./components/BasicTable";
import CollapsibleTable from "./components/CollapsibleTable";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";

const theme = createTheme({
  palette: {
    primary: {
      main: "#FABA02",
      contrastText: "#fff",
    },
  },
});

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      isLoaded: false,
      username: "",
    };
  }

  componentDidMount() {
    fetch(`${process.env.REACT_APP_BASE_URL}/api`)
      .then((res) => res.json())
      .then((json) => {
        this.setState({
          items: json,
          isLoaded: true,
          username: json["username"],
        });
      });
  }

  render() {
    if (this.state.items.error && this.state.items.error.length) {
      return (
        <ThemeProvider theme={theme}>
          <Container component="main" maxWidth="xs">
            <CssBaseline />
            <Box
              sx={{
                marginTop: 8,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Avatar sx={{ m: 1, bgcolor: "error.main" }}>
                <CloseIcon />
              </Avatar>
              <Typography
                component="h1"
                variant="h5"
                sx={{ textAlign: "center", mt: 2 }}
              >
                {this.state.items.error}
              </Typography>
              {this.state.items.statuscode &&
                this.state.items.statuscode.length && (
                  <Typography
                    component="subtitle1"
                    sx={{ textAlign: "center", mt: 2 }}
                  >
                    Statuscode: {this.state.items.statuscode}
                  </Typography>
                )}
              <Box sx={{ mt: 2 }}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                  onClick={() => {
                    window.location.replace(process.env.REACT_APP_LOGIN_URL);
                  }}
                >
                  Zurück zum Login
                </Button>
              </Box>
            </Box>
          </Container>
        </ThemeProvider>
      );
    } else {
      return (
        <ThemeProvider theme={theme}>
          <Box>
            <Menu username={this.state.username} />
            <CssBaseline />
            <Box
              component="main"
              sx={{
                backgroundColor: (theme) =>
                  theme.palette.mode === "light"
                    ? theme.palette.grey[100]
                    : theme.palette.grey[900],
                flexGrow: 1,
                minHeight: "calc(100vh - 64px)",
                overflow: "auto",
              }}
            >
              <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
                <Grid container spacing={3}>
                  {/* Chart */}
                  <Grid item xs={12} md={8} lg={6}>
                    <Paper>
                      {this.state.items.account &&
                        this.state.items.account.length && (
                          <BasicTable
                            title="Personenaccount – Details"
                            rows={this.state.items.account}
                          />
                        )}
                    </Paper>
                  </Grid>
                  {/* Recent Deposits */}
                  <Grid item xs={12} md={4} lg={6}>
                    <Paper>
                      {this.state.items.attachments &&
                        this.state.items.attachments.length && (
                          <BasicTable
                            title="Notizen und Anhänge"
                            rows={this.state.items.attachments}
                          />
                        )}
                    </Paper>
                  </Grid>
                  {/* Recent Orders */}
                  <Grid item xs={12}>
                    <Paper>
                      {this.state.items.tax_information &&
                        this.state.items.tax_information.length && (
                          <BasicTable
                            title="Steuer-Informationen"
                            rows={this.state.items.tax_information}
                          />
                        )}
                    </Paper>
                  </Grid>
                  <Grid item xs={12}>
                    <Paper>
                      {this.state.items.opportunities &&
                        this.state.items.opportunities.length && (
                          <CollapsibleTable
                            title="Vertragsbezogene Daten"
                            rows={this.state.items.opportunities}
                          />
                        )}
                    </Paper>
                  </Grid>
                </Grid>
              </Container>
            </Box>
          </Box>
        </ThemeProvider>
      );
    }
  }
}

export default App;
